import type { Ref } from 'vue'
import {
  type UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/vue-query'
import type { AxiosResponse } from 'axios'
import { PRIVATE_SUPPLIERS_QUERY_KEY } from '../queries'
import type { PrivateSupplierPayload } from '@/modules/Profile/types/api/payload/privateSupplier'
import type { CreatePrivateSupplierSuccessResponse } from '@/modules/Profile/types/api/response/privateSupplier'
import { axiosInstance } from '@/modules/Core/plugins/axios'

const ENDPOINT = '/tripmentor/Supplier'

export function createSupplier(payload: PrivateSupplierPayload) {
  return axiosInstance.post<CreatePrivateSupplierSuccessResponse>(
    ENDPOINT,
    payload
  )
}

export function useCreateMySupplierMutation(
  type: Ref<string>,
  options?: UseMutationOptions<
    AxiosResponse<CreatePrivateSupplierSuccessResponse>,
    AxiosCustomError,
    PrivateSupplierPayload,
    any
  >
) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createSupplier,
    async onSuccess() {
      await queryClient.invalidateQueries([PRIVATE_SUPPLIERS_QUERY_KEY, type])
    },
    ...options,
  })
}
